<div class="content-dropdown" (click)="toggleDropdown()">
  <div class="dropdown-header d-flex justify-content-between align-items-start">
    <h5 class="mb-0 flex-grow-1">{{ question }}</h5>
    <i class="fa-solid fa-chevron-down ms-3" [class.rotate]="isDropdownOpen"></i>
  </div>
  <div class="answer" [class.show]="isDropdownOpen">
    <p class="mb-0">{{ answer }}</p>
  </div>
</div>